// Import model
import { DictionaryFieldOptions } from '../models/DictionaryFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)
import { Field } from '../models/Field';

// Import dependency serializers (for complex types)
import { FieldSerializer } from './FieldSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DictionaryFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class DictionaryFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a DictionaryFieldOptions instance
   */
  static deserialize(json: string): DictionaryFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DictionaryFieldOptions instance
   */
  static fromObject(obj: any): DictionaryFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DictionaryFieldOptions');
    }


    const instance: DictionaryFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      expandAllKeys: obj['ExpandAllKeys'] as boolean | undefined,
      keyField: FieldSerializer.fromObject(obj['KeyField']),
      valueField: FieldSerializer.fromObject(obj['ValueField']),
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DictionaryFieldOptions instances
   */
  static deserializeArray(json: string): DictionaryFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DictionaryFieldOptions instance to a JSON string
   */
  static serialize(instance: DictionaryFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DictionaryFieldOptions instance to a plain object
   */
  static toObject(instance: DictionaryFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'ExpandAllKeys': instance.expandAllKeys,
      'KeyField': instance.keyField ? FieldSerializer.toObject(instance.keyField) : undefined,
      'ValueField': instance.valueField ? FieldSerializer.toObject(instance.valueField) : undefined,
    };
  }

  /**
   * Serializes an array of DictionaryFieldOptions instances to a JSON string
   */
  static serializeArray(instances: DictionaryFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
